/* Full-cart updates use current line identity, never the rendered row position. */
(function(root,factory){
  const exported=factory();
  if(typeof module==='object'&&module.exports)module.exports=exported;
  if(root&&root.document)root.OptionalCaseCart=exported.install(root);
})(typeof window!=='undefined'?window:null,function(){
  'use strict';
  const own=(value,key)=>Object.prototype.hasOwnProperty.call(value,key);
  const plain=value=>value!==null&&typeof value==='object'&&!Array.isArray(value);
  const quantity=value=>Number.isSafeInteger(value)&&value>=0;
  const fail=code=>{throw Object.assign(new Error(code),{code});};
  function attributes(value){
    if(Array.isArray(value)&&value.length===0)return Object.create(null);
    if(!plain(value)||Object.values(value).some(v=>v!==null&&!['string','number','boolean'].includes(typeof v)))fail('CART_INVALID');
    return Object.assign(Object.create(null),value);
  }
  function properties(value){
    if(value==null)return [];
    const entries=Array.isArray(value)?value:plain(value)?Object.entries(value):fail('IDENTITY_INVALID');
    const seen=new Set();
    return entries.map(pair=>{
      if(!Array.isArray(pair)||pair.length!==2||typeof pair[0]!=='string'||seen.has(pair[0])||!['string','number','boolean'].includes(typeof pair[1]))fail('IDENTITY_INVALID');
      seen.add(pair[0]);return [pair[0],String(pair[1])];
    }).sort((a,b)=>a[0].localeCompare(b[0]));
  }
  function normalizeIdentity(item){
    if(!item||typeof item.key!=='string'||!item.key)fail('IDENTITY_INVALID');
    const id=String(item.variantId??item.variant_id??'');
    const plan=item.sellingPlanId??item.selling_plan_allocation?.selling_plan?.id??null;
    if(!/^[1-9]\d*$/.test(id)||plan!==null&&!/^[1-9]\d*$/.test(String(plan)))fail('IDENTITY_INVALID');
    const signature=JSON.stringify([id,properties(item.properties),plan===null?null:String(plan)]);
    return {key:item.key,variantId:id,sellingPlanId:plan===null?null:String(plan),signature};
  }
  function resolveLine(items,identity){
    if(!Array.isArray(items))fail('CART_INVALID');
    const expected=identity.signature?identity:normalizeIdentity(identity);
    const exact=items.filter(item=>item.key===expected.key);
    if(exact.length){if(exact.length!==1||normalizeIdentity(exact[0]).signature!==expected.signature)fail('CART_CHANGED');return exact[0];}
    const matches=items.filter(item=>String(item.variant_id??item.variantId??'')===expected.variantId).filter(item=>normalizeIdentity(item).signature===expected.signature);
    if(matches.length!==1)fail('CART_CHANGED');
    return matches[0];
  }
  function install(win,options){
    options=options||{};
    const doc=win.document,states=new WeakMap(),fetcher=options.fetch||win.fetch?.bind(win);
    const refresh=options.refresh||function(url){win.location.assign(url);};
    const timeoutMs=options.timeoutMs??15000;
    const messages={pending:'Updating your cart…',changed:'Your cart changed. Review the items and try again.',error:"We couldn't confirm the update. Review your cart before trying again.",note:"We couldn't confirm your note. It is still shown below. Copy it before reloading."};
    function status(state,text){state.status.textContent=text;}
    function cartUrl(state){const url=new URL(state.routes.cart,win.location.href);const preview=new URL(win.location.href).searchParams.get('preview_theme_id');if(preview&&/^\d+$/.test(preview))url.searchParams.set('preview_theme_id',preview);return url.href;}
    function navigate(state,notice){
      state.navigating=true;stripNames(state);
      if(notice){try{win.sessionStorage.setItem('optionalCaseCartNotice',notice);}catch(_){}status(state,messages[notice]||messages.changed);}
      refresh(cartUrl(state));
    }
    function stripNames(state){state.form.querySelectorAll('input[name^="updates["],select[name^="updates["],textarea[name^="updates["]').forEach(el=>el.removeAttribute('name'));}
    function metadataFields(state){return Array.from(state.form.elements).filter(el=>el.name==='note'||/^attributes\[[^\]]+\]$/.test(el.name));}
    function readMeta(state){
      const result={note:state.form.querySelector('[name="note"]')?.value,attributes:Object.create(null)};
      for(const el of metadataFields(state)){
        const match=/^attributes\[([^\]]+)\]$/.exec(el.name);if(!match)continue;
        if(el.disabled&&!state.locked.has(el))continue;
        if(['checkbox','radio'].includes(el.type)&&!el.checked){if(!own(result.attributes,match[1]))result.attributes[match[1]]='';continue;}
        if(el.type==='file')continue;
        result.attributes[match[1]]=String(el.value??'');
      }
      return result;
    }
    function metadataPayload(state,draft){
      const payload={};if(draft.note!==undefined&&draft.note!==state.baseline.note)payload.note=draft.note;
      const attributes=Object.create(null);
      for(const [key,value]of Object.entries(draft.attributes))if(value!==String(state.baseline.attributes[key]??''))attributes[key]=value;
      if(Object.keys(attributes).length)payload.attributes=attributes;
      return payload;
    }
    function acknowledgeMeta(state,payload){if(own(payload,'note'))state.baseline.note=payload.note;for(const [key,value]of Object.entries(payload.attributes||{}))state.baseline.attributes[key]=value;}
    function metaMatches(cart,draft){
      if(!draft||!Object.keys(draft).length)return true;
      if(!cart)return false;
      if(own(draft,'note')&&String(cart.note??'')!==draft.note)return false;
      return Object.entries(draft.attributes||{}).every(([key,value])=>String(cart.attributes?.[key]??'')===value);
    }
    function setBusy(state,busy){
      state.form.setAttribute('aria-busy',String(busy));
      if(busy){
        metadataFields(state).forEach(el=>{if(!el.disabled){state.locked.add(el);el.disabled=true;}});
        state.form.querySelectorAll('[name="checkout"],[data-cart-checkout-button]').forEach(el=>{if(!el.disabled){state.disabledCheckout.add(el);el.disabled=true;}});
        state.form.querySelectorAll('.additional-checkout-buttons,[data-shopify="payment-button"]').forEach(el=>{if(!el.hasAttribute('inert')){state.express.add(el);el.setAttribute('inert','');}});
      }else{
        state.locked.forEach(el=>{el.disabled=false;});state.locked.clear();
        state.disabledCheckout.forEach(el=>{el.disabled=false;});state.disabledCheckout.clear();
        state.express.forEach(el=>el.removeAttribute('inert'));state.express.clear();
      }
    }
    function hold(state,text){
      state.halted=true;state.queue.length=0;setBusy(state,false);stripNames(state);status(state,text);
      state.form.querySelectorAll('[name="checkout"],[data-cart-checkout-button]').forEach(el=>{el.disabled=true;});
      state.form.querySelectorAll('.additional-checkout-buttons,[data-shopify="payment-button"]').forEach(el=>el.setAttribute('inert',''));
      if(state.routes?.cart){const reload=doc.createElement('a');reload.href=cartUrl(state);reload.textContent=' Reload cart';state.status.appendChild(reload);}
    }
    async function request(state,name,payload){
      if(typeof fetcher!=='function')fail('REQUEST_FAILED');
      const controller=typeof win.AbortController==='function'?new win.AbortController():null;
      let timer;
      const timed=new Promise((_,reject)=>{timer=win.setTimeout(()=>{controller?.abort();reject(Object.assign(new Error('REQUEST_TIMEOUT'),{code:'REQUEST_TIMEOUT'}));},timeoutMs);});
      try{
        const response=await Promise.race([fetcher(state.routes[name],{method:payload===undefined?'GET':'POST',credentials:'same-origin',cache:'no-store',redirect:'error',headers:payload===undefined?{Accept:'application/json'}:{Accept:'application/json','Content-Type':'application/json'},...(payload===undefined?{}:{body:JSON.stringify(payload)}),...(controller?{signal:controller.signal}:{})}),timed]);
        if(!response?.ok)fail('REQUEST_FAILED');
        const cart=await Promise.race([response.json(),timed]);
        if(!plain(cart)||!Array.isArray(cart.items)||!own(cart,'note')||cart.note!==null&&typeof cart.note!=='string')fail('CART_INVALID');
        cart.attributes=attributes(cart.attributes);
        const keys=new Set();cart.items.forEach(item=>{if(!item||typeof item.key!=='string'||!item.key||keys.has(item.key)||!quantity(item.quantity)||item.quantity===0)fail('CART_INVALID');keys.add(item.key);});
        state.lastCart=cart;
        return cart;
      }finally{win.clearTimeout(timer);}
    }
    function rowReference(state,row){
      if(!row||row.closest('form')!==state.form)fail('IDENTITY_INVALID');
      let ref=state.rows.get(row);if(ref)return ref;
      const raw=JSON.parse(row.getAttribute('data-optional-cart-line')||'null'),identity=normalizeIdentity(raw);
      if(!quantity(raw.quantity)||raw.quantity===0)fail('IDENTITY_INVALID');
      ref={row,identity,ackQuantity:raw.quantity,pendingRemove:false,removed:false,lastQueued:null};state.rows.set(row,ref);return ref;
    }
    async function saveMeta(state){
      const payload=metadataPayload(state,state.draft);if(!Object.keys(payload).length)return;
      const before=await request(state,'read');
      if((own(payload,'note')&&String(before.note??'')!==state.baseline.note&&String(before.note??'')!==payload.note)||Object.entries(payload.attributes||{}).some(([key,value])=>String(before.attributes?.[key]??'')!==String(state.baseline.attributes[key]??'')&&String(before.attributes?.[key]??'')!==value))throw Object.assign(new Error('CART_CHANGED'),{code:'CART_CHANGED',cart:before});
      if(metaMatches(before,payload)){acknowledgeMeta(state,payload);return;}
      if(state.invalidated)fail('INTERRUPTED');
      const result=await request(state,'update',payload);
      // The update carries only edited metadata; never an entire quantity map.
      if((own(payload,'note')&&String(result.note??'')!==payload.note)||Object.entries(payload.attributes||{}).some(([key,value])=>String(result.attributes?.[key]??'')!==value))fail('METADATA_UNCONFIRMED');
      acknowledgeMeta(state,payload);
    }
    async function operation(state,intent){
      const ref=intent.ref;if(ref.removed)return;
      if(state.invalidated)fail('INTERRUPTED');
      await saveMeta(state);
      if(state.invalidated)fail('INTERRUPTED');
      const cart=await request(state,'read'),line=resolveLine(cart.items,ref.identity);
      if(line.quantity!==ref.ackQuantity)throw Object.assign(new Error('CART_CHANGED'),{code:'CART_CHANGED',cart});
      ref.identity=normalizeIdentity(line);
      if(state.invalidated)fail('INTERRUPTED');
      const result=await request(state,'change',{id:line.key,quantity:intent.quantity});
      if(intent.quantity===0){ref.removed=true;ref.ackQuantity=0;return;}
      const changed=resolveLine(result.items,ref.identity);
      if(changed.quantity!==intent.quantity)throw Object.assign(new Error('CART_CHANGED'),{code:'CART_CHANGED',cart:result});
      ref.identity=normalizeIdentity(changed);ref.ackQuantity=changed.quantity;
    }
    async function stop(state,error){
      state.halted=true;state.queue.length=0;
      if(state.invalidated||state.navigating){hold(state,messages.changed);return;}
      let cart=error.cart;try{if(!cart)cart=await request(state,'read');}catch(_){}
      setBusy(state,false);stripNames(state);
      // A failed/uncertain write is never replayed. Read once to reconcile and
      // refresh only if doing so cannot discard the customer's unsaved draft.
      if(metaMatches(cart,state.requiredMeta)){hold(state,messages.changed);navigate(state,error.code==='CART_CHANGED'?'changed':'error');return;}
      hold(state,messages.note);
    }
    function start(state){
      if(state.running)return state.promise;
      state.running=true;state.draft=readMeta(state);state.requiredMeta=metadataPayload(state,state.draft);setBusy(state,true);status(state,messages.pending);
      state.promise=Promise.resolve().then(async()=>{
        try{
          while(state.queue.length){const intent=state.queue.shift();await operation(state,intent);}
          if(state.invalidated)return;
          if(!metaMatches(state.lastCart,state.requiredMeta))fail('METADATA_UNCONFIRMED');
          navigate(state);
        }catch(error){await stop(state,error);}
        finally{state.running=false;}
      });return state.promise;
    }
    function change(row,value){
      const form=row?.closest('form[data-optional-case-cart]');if(!form)return Promise.resolve(false);
      const state=bind(form);if(!state||state.halted||state.navigating)return Promise.resolve(false);
      try{
        if(!quantity(value))fail('QUANTITY_INVALID');
        const ref=rowReference(state,row);if(ref.removed||ref.pendingRemove&&value!==0)return state.promise||Promise.resolve(false);
        if(ref.pendingRemove&&value===0||state.running&&ref.lastQueued===value)return state.promise;
        if(value===0)ref.pendingRemove=true;
        ref.lastQueued=value;state.queue.push({ref,quantity:value});return start(state);
      }catch(_){hold(state,messages.changed);return Promise.resolve(false);}
    }
    function changedInputs(state){
      const changes=[];
      for(const row of state.form.querySelectorAll('[data-cart-item]')){
        const field=row.querySelector('[data-cart-quantity-input]');if(!field)continue;
        const raw=String(field.value).trim();if(!/^\d+$/.test(raw)||!quantity(Number(raw)))fail('QUANTITY_INVALID');
        const ref=rowReference(state,row);if(Number(raw)!==ref.ackQuantity)changes.push([row,Number(raw)]);
      }return changes;
    }
    function submit(form){
      const state=bind(form);if(!state||state.halted||state.navigating)return Promise.resolve(false);
      stripNames(state);if(state.running)return state.promise;
      try{const changes=changedInputs(state);if(changes.length){changes.forEach(([row,q])=>change(row,q));return state.promise;}}
      catch(_){status(state,'Enter a valid quantity before checking out.');return Promise.resolve(false);}
      return Promise.resolve(form.checkValidity());
    }
    function bind(form){
      if(states.has(form))return states.get(form);
      const node=form.querySelector('[data-optional-cart-status]')||doc.createElement('p');
      if(!node.parentNode){node.setAttribute('data-optional-cart-status','');node.setAttribute('role','status');node.setAttribute('aria-live','polite');form.prepend(node);}
      const state={form,status:node,rows:new WeakMap(),queue:[],running:false,halted:false,navigating:false,locked:new Set(),disabledCheckout:new Set(),express:new Set(),promise:Promise.resolve()};states.set(form,state);stripNames(state);
      function guardSubmit(event){
        stripNames(state);
        if(state.halted||state.navigating||state.running){event?.preventDefault();event?.stopImmediatePropagation();status(state,state.halted?messages.changed:messages.pending);return false;}
        try{
          const changes=changedInputs(state);
          if(changes.length){event?.preventDefault();event?.stopImmediatePropagation();changes.forEach(([row,q])=>change(row,q));return false;}
          return true;
        }catch(_){event?.preventDefault();event?.stopImmediatePropagation();status(state,'Enter a valid quantity before checking out.');return false;}
      }
      form.addEventListener('submit',guardSubmit,true);
      const nativeSubmit=form.submit;
      if(typeof nativeSubmit==='function')Object.defineProperty(form,'submit',{configurable:true,value:function(){if(guardSubmit()&&form.checkValidity())nativeSubmit.call(form);}});
      try{
        const raw=JSON.parse(form.getAttribute('data-cart-routes')||'null'),meta=JSON.parse(form.getAttribute('data-cart-meta')||'null');if(!plain(raw)||!plain(meta))fail('CART_INVALID');
        state.routes={};for(const name of ['cart','read','change','update']){
          const url=new URL(raw[name],win.location.href),suffix={cart:'/cart',read:'/cart.js',change:'/cart/change.js',update:'/cart/update.js'}[name];
          if(typeof raw[name]!=='string'||url.origin!==win.location.origin||url.search||url.hash||!url.pathname.endsWith(suffix))fail('ROUTE_INVALID');state.routes[name]=url.href;
        }
        state.baseline={note:String(meta.note??''),attributes:attributes(meta.attributes)};
        form.querySelectorAll('[data-cart-item]').forEach(row=>rowReference(state,row));
        try{const notice=win.sessionStorage.getItem('optionalCaseCartNotice');win.sessionStorage.removeItem('optionalCaseCartNotice');if(messages[notice])status(state,messages[notice]);}catch(_){}
      }catch(_){hold(state,messages.changed);return state;}
      // Idle native checkout and Route hooks retain the original event path.
      // Only quantity fields are excluded from a native metadata/checkout POST.
      return state;
    }
    function bindAll(){doc.querySelectorAll('form[data-optional-case-cart]').forEach(bind);}
    bindAll();if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',bindAll,{once:true});
    win.addEventListener('pagehide',function(){doc.querySelectorAll('form[data-optional-case-cart]').forEach(form=>{const state=states.get(form);if(state){state.invalidated=true;state.queue.length=0;}});});
    win.addEventListener('pageshow',function(event){if(!event.persisted)return;doc.querySelectorAll('form[data-optional-case-cart]').forEach(form=>{
      const state=bind(form);if(!state.routes?.cart)return;
      try{
        if(Object.keys(metadataPayload(state,readMeta(state))).length||changedInputs(state).length){hold(state,'Your cart may have changed. Your unsaved changes are still shown below. Copy them before reloading.');return;}
      }catch(_){hold(state,messages.changed);return;}
      setBusy(state,true);navigate(state,'changed');
    });});
    return {bind,change,submit,whenIdle:form=>states.get(form)?.promise||Promise.resolve()};
  }
  return {install,normalizeIdentity,resolveLine};
});
